<h3 anessaTranslation="DROPDOWN.SAVE_AS"></h3>
<form>
  <mat-form-field appearance="outline">
    <mat-label anessaTranslation="DROPDOWN.PROJ_TITLE"></mat-label>
    <input name="title" id="title" type="text" matInput [(ngModel)]="title">
  </mat-form-field>
  <button type="submit" mat-raised-button class="mat-raised-button btn-green" (click)="onSave()" anessaTranslation="PROJECT.COMMON.SAVE"></button>
  <button type="button" mat-raised-button class="mat-raised-button btn-red" (click)="onCancel()" anessaTranslation="PROJECT.COMMON.CANCEL"></button>
</form>